
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { serviceurl, geoserver_url } from '../constant/constant';
import { workspace } from '../constant/maplayers'
import { CellResourceDetailsPayload } from '../models/cell-resource-details.model';
import { ContentAttachPayload } from '../pages/content-creator/add-content/models/content.model';

@Injectable({
  providedIn: 'root'
})

export class DataService {


  constructor(private http: HttpClient,
    private router: Router) { }

  Getmaplist(user_id: Number | string) {
    return this.http.get(serviceurl + 'getmaps/GetMaplistbyUseridAPI/' + user_id + '/');
  }
  getMapUploadStatus(mapId: string | number) {
    return this.http.get(serviceurl + 'api/maps/upload-status/' + mapId + '/');
  }
  getWorldCreationStatus(mapId: string | number) {
    return this.http.get(serviceurl + 'api/map-creation/status/' + mapId + '/');
  }
  sendGameAndInvitations(data: any) {
    return this.http.post(serviceurl + 'game/create-game-and-invite/', data);
  }

  createmap(data: any) {
    return this.http.post(serviceurl + 'maplist/createmap/', data);
  }

  updatemap(data: any) {
    return this.http.post(serviceurl + 'maplist/updatemap/', data);
  }

  getMapData(mapService: any, mapId: any) {
    return this.http.get(serviceurl + mapService + '/' + mapId + '/')
  }

  deletemap(map_ids: any, userid: any) {
    if (map_ids && Array.isArray(map_ids))
      return this.http.post(serviceurl + 'maplist/delete/' + userid + '/', { map_codes: map_ids })
    else
      return this.http.post(serviceurl + 'maplist/delete/' + userid + '/', { map_codes: [map_ids] })
  }

  getboundaryData(mapid) {
    return this.http.get(geoserver_url + '/geoserver/' + workspace + '/ows?service=WFS&version=1.0.0&' + 'request=GetFeature&typeName=newfantasy%3Aboundary&maxFeatures=50&outputFormat=application%2Fjson&VIEWPARAMS=mapcode:' + mapid)
  }

  getCityData(mapid, cityid) {
    return this.http.get(serviceurl + 'getcitydata/' + mapid + '/' + cityid + '/');
  }

  Getcharacterdetail(user_id: number, map_code?: any) {
    const url = map_code
      ? `${serviceurl}character/Getcharacterdetailsbyuserid/${user_id}/?map_code=${map_code}&notification=true`
      : `${serviceurl}character/Getcharacterdetailsbyuserid/${user_id}/`;

    return this.http.get(url);
  }




  Getcharacterdetailbychar_id(char_id: any) {
    return this.http.get(serviceurl + 'character/Getcharacterdetailbycharacterid/' + char_id + '/');
  }

  createcharacterdetail(data: any) {
    return this.http.post(serviceurl + 'character/createcharacterdetails/', data);
  }

  updatecharacterdetail(character_id: any, data: any) {
    return this.http.put(serviceurl + 'character/updateCharcterdetails/' + character_id + '/', data);
  }

  getactivegames(user_id: Number) {
    return this.http.get(serviceurl + 'gamemaster/Getgamemaster/' + user_id + '/');
  }

  getpartybygame(id: Number, user_id?: any) {
    return this.http.get(serviceurl + `api/party/get-party-by-game/?game_id=${id}&user_id=${user_id}`);
  }

  playerList(id: Number) {
    return this.http.get(serviceurl + 'character/Getcharacterdetailsbygameid/' + id + '/');
  }


  creategame(data: any) {
    return this.http.post(serviceurl + 'gamemaster/creategamemaster/', data);
  }

  activegameimgupload(data: any) {
    return this.http.put(serviceurl + 'gamemaster/gamemasterimageupload/', data);
  }

  gamedetailimgupload(data: any) {
    return this.http.put(serviceurl + 'gameuser/UpdatedGameDetailsImageByGameId/', data);
  }


  sendemail(data: any, game_id: number) {
    return this.http.put(serviceurl + `game/update-game-and-invite/${game_id}/`, data);
  }

  get_pending_invitationlist(user_id: any) {
    return this.http.get(serviceurl + 'Invitation/invitationbystatus/PENDING/' + user_id + '/');
  }

  get_previous_invitationlist(user_id: any) {
    return this.http.get(serviceurl + 'Invitation/invitationbystatus/ACCEPTED,REJECTED/' + user_id + '/');
  }

  get_invitationdetail(userid, invitationid) {
    return this.http.get(serviceurl + 'Invitation/listofemailbyuserid/' + userid + '/' + invitationid + '/');
  }

  get_charlist_by_email(email_id: any, map_code: any) {
    return this.http.get(serviceurl + 'Invitation/charaterdetails/' + email_id + '/' + map_code + '/');
  }

  invitationdetailstatusupdate(data) {
    return this.http.post(serviceurl + 'Invitation/characterid/updatestatus/', data);
  }

  getproductlist(tabletype: string) {
    return this.http.get(serviceurl + 'gamesystem/' + tabletype + '/');
  }

  turmsandconditioncheck(data: any) {
    return this.http.post(serviceurl + 'gameuser/termsCondition/', data);
  }

  gamedetailby_game_id(game_id: Number) {
    return this.http.get(serviceurl + 'gameuser/GameDetailsByGameId/' + game_id + '/');
  }

  // ACCEPTED CHARACTER LIST 
  get_approved_charlist() {
    return this.http.get(serviceurl + 'Invitation/invitationbystatus/ACCEPTED/');
  }

  // PENDING AND REJECTED CHARACTER LIST
  get_charlist() {
    return this.http.get(serviceurl + 'Invitation/invitationbystatus/PENDING,REJECTED/');
  }

  getsexlist() {
    return this.http.get(serviceurl + 'gamesystem/Sex/');
  }

  //Add last played time 
  playgame(data) {
    return this.http.put(serviceurl + 'gameuser/UpdatedGameDetailsDateByGameId/', data);
  }

  chnggamedetail(data: any) {
    return this.http.put(serviceurl + 'gameuser/UpdatedGameDataByGameId/', data);
  }

  // remove approved characterlist
  deleteappcharlist(character_id: any, game_id: any) {
    return this.http.delete(serviceurl + 'Invitation/InvitationDelete/' + character_id + '/' + game_id + '/');
  }

  //Remove Panding and rejected characterlist
  delete_p_r_charlist(invitaion_id: any) {
    return this.http.delete(serviceurl + 'Invitation/InvitationDeletebyuserid/' + invitaion_id + '/');
  }

  getCharacterBasicDetailByGameId(char_id, game_id) {
    return this.http.get(serviceurl + 'Getcharctername/gameid/characterid/' + char_id + '/' + game_id + '/')
  }

  getHistoryDetailByCharacterId(character_id, mapCode) {
    return this.http.get(serviceurl + `locationdetails/${character_id}/${mapCode}/`)
  }
  partylocationhistory(game_id, mapCode) {
    return this.http.get(serviceurl + `api/party/party-location-history/${game_id}/${mapCode}/`)
  }

  updateHistoryRecord(historyData) {
    return this.http.put(serviceurl + `location_details/update/${historyData.id}/`, historyData)
  }
  citylocationhistory(historyData) {
    return this.http.put(serviceurl + `api/party/update-city-location-history/${historyData.id}/`, historyData)
  }

  getSavedLocationData(charId) {
    return this.http.get(serviceurl + `/sharedlocation/getbycharacteridlocationid/${charId}/`)
  }

  updateFavroiteStatus(data) {
    const dataObj = {
      id: data.id
    }
    return this.http.post(serviceurl + `location/toggle-bookmark/`, dataObj)
  }

  getFavroiteRecords(charId: number, map_id?: string) {
    const char_id = Number(charId);
    return this.http.get(serviceurl + `location/favourite/${char_id}/`, {
      params: { map_id }  // map_id can be undefined, that's fine
    });
  }

  getFavroiteRecordsByMapId(userId: number | string, context: 'map' | 'city') {
    const user_id = Number(userId);
    return this.http.get(serviceurl + `favorite/list/${user_id}/?context=${context}`, {
      headers: new HttpHeaders({ 'loader': 'Loading your favorites...' })
    })
  }

  getContentDetailsByUserId(userId, contentId) {
    return this.http.get(serviceurl + `api/ui/content/${contentId}/?user_id=${userId}`)
  }

  createContent(data, userId) {
    // Was hardcoded to production so WordPress could fetch the uploads from a
    // public host during local dev. Deployed builds' serviceurl already is that
    // host, and with the in-app store (STORE_BACKEND=marketplace) WordPress
    // isn't involved — so creates follow the configured API like everything else.
    return this.http.post(serviceurl + `api/ui/content/create/${userId}/`, data)
  }

  updateContentById(id, data, userId) {
    return this.http.post(serviceurl + `api/ui/content/update/${id}/${userId}/`, data)
  }

  deleteContentById(id, userId?) {
    return this.http.post(serviceurl + `api/ui/content/delete/${id}/${userId}/`, {})
  }

  getContentDataByMapId(userId, map_id: string) {
    return this.http.get(serviceurl + `api/ui/content/map/${map_id}/?user_id=${userId}`, {
      headers: new HttpHeaders({ 'loader': 'Loading the pins on this map...' })
    })
  }

  getContentDataByUserId(userId, filters?: any) {
    let url = serviceurl + `api/ui/content/all/${userId}/`;
    if (filters) {
      const params = new URLSearchParams();
      Object.keys(filters).forEach(key => {
        if (filters[key]) {
          params.append(key, filters[key]);
        }
      });
      const queryString = params.toString();
      if (queryString) {
        url += `?${queryString}`;
      }
    }
    return this.http.get(url)
  }

  getMapGenre(mapCode: string | number, gameId?: string | number) {
    let url = serviceurl + `getmapgenre/${mapCode}/`;
    if (gameId) {
      url += `?game_id=${gameId}`;
    }
    return this.http.get(url, {
      headers: new HttpHeaders({ 'loader': 'Getting this world\'s details...' })
    });
  }

  contentAttach(data: ContentAttachPayload) {
    return this.http.post(serviceurl + `api/ui/content/attach/`, data, {
      headers: new HttpHeaders({ 'loader': 'Pinning your content...' })
    })
  }

  deleteImageFromContent(id) {
    return this.http.delete(serviceurl + `api/content/contentfile/delete-particularcontenfile/${id}/`)
  }

  getContentDataOfPlayersByMapCode(mapcode) {
    return this.http.get(serviceurl + `api/content/getlist-mapcode/${mapcode}/`)
  }

  deleteGame(id) {
    return this.http.post(serviceurl + `gamemaster/deletegamemaster/${id}/`, {})
  }

  deleteCharacter(id: number, game_id: number) {
    let url = `${serviceurl}characters/delete/`;

    // Append game_id only if it exists
    if (game_id !== undefined && game_id !== null) {
      url += `?game_id=${game_id}`;
    }
    if (id && Array.isArray(id)) {
      return this.http.post(url, { character_ids: id })
    }
    else {
      return this.http.post(url, { character_ids: [id] })
    }

  }


  sendMapInvites(data) {
    return this.http.post(serviceurl + `api/invite-player-map/`, data)
  }

  getMapInvitationByUserId(user_id) {
    return this.http.get(serviceurl + `api/get-pending-invitations/${user_id}/`)
  }

  accept_reject_invitation_for_map(data) {
    return this.http.post(serviceurl + `api/respond-to-invitation/`, data)
  }

  getSentMapInvitations(user_id: number | string, map_id?: number | string) {
    if (map_id) {
      return this.http.get(serviceurl + `api/map/invitations/sent/${user_id}/?map_id=${map_id}`);
    } else {
      return this.http.get(serviceurl + `api/map/invitations/sent/${user_id}/`);
    }
  }

  cancelMapInvitation(user_id: number | string, invitation_id: number | string) {
    return this.http.delete(serviceurl + `api/map/cancel-invitation/${invitation_id}/${user_id}/`);
  }


  getBurgsData(mapcode: any, burg_id: string | number) {
    return this.http.get(serviceurl + `/getburgsdata/${mapcode}/?burg_id=${burg_id}`)
  }
  getLegendData(mapcode: string | number, layer_name: string) {
    return this.http.get(serviceurl + `/getlegend?map_code=${mapcode}&type=${layer_name}`, {
      headers: new HttpHeaders({ 'loader': 'Loading the map layer...' })
    })
  }

  uninviteUsers(game_id, selectedPendingInvitationMails) {
    return this.http.post(serviceurl + `api/uninvite/`, { game_id, emails: selectedPendingInvitationMails })
  }

  getCustomCellData(payload: CellResourceDetailsPayload) {
    return this.http.post(serviceurl + `api/cell-resource-details/`, { ...payload })
  }

  resendInvitation(id: any, pendingInvitationEmails: string[]) {
    const payload = {
      game_id: id,
      emails: pendingInvitationEmails
    }
    return this.http.post(serviceurl + `api/resend-invites/`, payload);
  }

  updatepartylocationhistory(historyData) {
    return this.http.put(serviceurl + `api/update-party-location-history/${historyData.id}/`, historyData)
  }

  getNotificationCount(userId: number | string) {
    return this.http.get(serviceurl + `api/invitation/count/${userId}/`);
  }

  downloadContentFiles(contentId: number | string) {
    return this.http.get(serviceurl + `api/ui/content/${contentId}/download/`, { responseType: 'blob' });
  }

  sendCurrentTimeOfPlay(game_id) {
    return this.http.post(serviceurl + `gamemaster/${game_id}/activity/`, {});
  }

  saveContentToFavorites(user_id: string | number, wp_usage_id: number | string) {
    return this.http.post(serviceurl + `/favorite/toggle/${user_id}/${wp_usage_id}/`, {})
  }

  checkFavorite(user_id: string | number, wp_usage_id: number | string) {
    return this.http.get(serviceurl + `/favorite/check/${user_id}/${wp_usage_id}/`)
  }

  saveContentToCityFavorites(user_id: string | number, content_id: number | string) {
    return this.http.post(serviceurl + `api/content-city/favorite/${user_id}/${content_id}/`, {})
  }

  reportContent(user_id: string | number, paylod: { content_id: number | string, reason: string, content_type: 'content' | 'city' }) {
    return this.http.post(serviceurl + `api/report-content/${user_id}/`, paylod)
  }

  downloadFieldGuide(mapId: string) {
    return this.http.get(serviceurl + `api/map-creation/field-guide/${mapId}/`, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  downloadGmGuide(mapId: string) {
    return this.http.get(serviceurl + `api/map-creation/gm-guide/${mapId}/`, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  cancelMapUpload(mapId: string, userId: string | number) {
    return this.http.post(`${serviceurl}api/maps/cancel-upload/${mapId}/`, {
      user_id: userId
    });
  }
}
